// extracted by mini-css-extract-plugin
export default {"container":"Privacy_container__8UDrH","heading":"Privacy_heading__R9Z2a","updated":"Privacy_updated__fuY+j","logoo":"Privacy_logoo__mWsJj","contentdiv":"Privacy_contentdiv__t3Znb"};